import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const NotificationsHeader = () => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <div className="page-title">
        <h2>
          <i className="far fa-bell" />
          {intl.formatMessage({ defaultMessage: 'Notifications' })}
        </h2>
      </div>
      <div className="header-actions">
        <Button
          color="primary"
          tag={Link}
          to="/profile/edit?tab=notifications"
        >
          <i className="far fa-cog" />{' '}
          {intl.formatMessage({ defaultMessage: 'Settings' })}
        </Button>
      </div>
    </header>
  );
};

export default NotificationsHeader;
